const StorageToken = {
  set: (data: string) => {
    localStorage.setItem('@gympass:token', data)
  },
  get: () => {
    return localStorage.getItem('@gympass:token')
  },
}

export default StorageToken;